import api from './api';

const URLS = {
  listDestinoByFilter: 'listDestinoByFilter',
  createDestino: 'createDestino',
  updateDestino: 'updateDestino',
  removeDestino: 'removeDestino',
  sendSolicitudDecreto: 'sendSolicitudDecreto',
  listTipoVehiculoSitioWeb: 'listTipoVehiculoSitioWeb',
  listVehiculoSitioWeb: 'listVehiculoSitioWeb',
  findBoletinOficialVigente: 'findBoletinOficialVigente',
  listBoletinOficialVigenteOrdenanzaSitioWeb: 'listBoletinOficialVigenteOrdenanzaSitioWeb',
  listBoletinOficialVigenteDecretoSitioWeb: 'listBoletinOficialVigenteDecretoSitioWeb',
  listDocumentoBoletinOficialSitioWeb: 'listDocumentoBoletinOficialSitioWeb',
  listAreaMunicipalSitioWeb: 'listAreaMunicipalSitioWeb',
  findEjecutivoIntendencia: 'findEjecutivoIntendencia',
  listEjecutivoSecretariaSitioWeb: 'listEjecutivoSecretariaSitioWeb',
  listHcdSitioWeb: 'listHcdSitioWeb',
  findObservatorioVial: 'findObservatorioVial',
  listDocumentoMovimientoTerminalSitioWeb: 'listDocumentoMovimientoTerminalSitioWeb',
  listDocumentoInformeEstadisticoSitioWeb: 'listDocumentoInformeEstadisticoSitioWeb',
  listSliderByGallerySitioWeb: 'listSliderByGallerySitioWeb',
  listDocumentoEstadoContableSitioWeb: 'listDocumentoEstadoContableSitioWeb',
  listDocumentoSueldoSitioWeb: 'listDocumentoSueldoSitioWeb',
  listPosiciones: 'listPosiciones',
};

export const listDestinoByFilter = (filterData) => {
  return api.post(URLS.listDestinoByFilter, filterData);
};

export const createDestino = (destinoData) => {
  return api.post(URLS.createDestino, destinoData);
};

export const updateDestino = (destinoData) => {
  return api.post(URLS.updateDestino, destinoData);
};

export const removeDestino = (destinoId) => {
  return api.delete(URLS.removeDestino + '?idDestino=' + destinoId);
};

export const sendSolicitudDecreto = (solicitudDecretoRequest) => {
  return api.post(URLS.sendSolicitudDecreto, solicitudDecretoRequest);
};

export const listTipoVehiculoSitioWeb = (pattern) => {
  return api.get(URLS.listTipoVehiculoSitioWeb + '?pattern=' + pattern);
};

export const listVehiculoSitioWeb = (pattern) => {
  return api.get(URLS.listVehiculoSitioWeb + '?pattern=' + pattern);
};

export const findBoletinOficialVigente = () => {
  return api.get(URLS.findBoletinOficialVigente);
};

export const listBoletinOficialVigenteOrdenanzaSitioWeb = (pattern) => {
  return api.get(URLS.listBoletinOficialVigenteOrdenanzaSitioWeb + '?pattern=' + pattern);
};

export const listBoletinOficialVigenteDecretoSitioWeb = (pattern) => {
  return api.get(URLS.listBoletinOficialVigenteDecretoSitioWeb + '?pattern=' + pattern);
};

export const listDocumentoBoletinOficialSitioWeb = () => {
  return api.get(URLS.listDocumentoBoletinOficialSitioWeb);
};

export const listAreaMunicipalSitioWeb = () => {
  return api.get(URLS.listAreaMunicipalSitioWeb + '?pattern=');
};

export const findEjecutivoIntendencia = () => {
  return api.get(URLS.findEjecutivoIntendencia);
};

export const listEjecutivoSecretariaSitioWeb = () => {
  return api.get(URLS.listEjecutivoSecretariaSitioWeb + '?pattern=');
};

export const listHcdSitioWeb = () => {
  return api.get(URLS.listHcdSitioWeb);
};

export const findObservatorioVial = () => {
  return api.get(URLS.findObservatorioVial);
};

export const listDocumentoMovimientoTerminalSitioWeb = () => {
  return api.get(URLS.listDocumentoMovimientoTerminalSitioWeb);
};

export const listDocumentoInformeEstadisticoSitioWeb = () => {
  return api.get(URLS.listDocumentoInformeEstadisticoSitioWeb);
};

export const listSliderByGallerySitioWeb = (gallery) => {
  return api.get(URLS.listSliderByGallerySitioWeb + '?gallery=' + gallery);
};

export const listDocumentoEstadoContableSitioWeb = () => {
  return api.get(URLS.listDocumentoEstadoContableSitioWeb);
};

export const listDocumentoSueldoSitioWeb = () => {
  return api.get(URLS.listDocumentoSueldoSitioWeb);
};

export const listPosiciones = () => {
  return api.get(URLS.listPosiciones);
};
